import { render, staticRenderFns } from "./Tab_Carousel.vue?vue&type=template&id=7f463f97&scoped=true&"
import script from "./Tab_Carousel.vue?vue&type=script&lang=js&"
export * from "./Tab_Carousel.vue?vue&type=script&lang=js&"
import style0 from "./Tab_Carousel.vue?vue&type=style&index=0&id=7f463f97&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f463f97",
  null
  
)

export default component.exports